import gender from './gender.json';
import timeout from './timeout';

export default {
  common: {
    ...gender,
    ...timeout,
  },
};
